import { Flex, Separator, Text } from "@radix-ui/themes";
import { useMatchRoute, useNavigate } from "@tanstack/react-router";

import LeftNav from "@/components/nav/LeftNav";
import NavButton from "@/components/nav/LeftNav/NavButton";

import { MusicNoteIcon } from "@/assets/icons";

export default function FilterSection() {
  const navigate = useNavigate();
  const matchRoute = useMatchRoute();

  const isAlbums = !!matchRoute({ to: "/marketplace/albums" });

  return (
    <LeftNav>
      <Flex direction="column" className="gap-[4px] pb-[16px]">
        <Text className="text-text-secondary text-[14px] mb-[5px]">
          Discover Music
        </Text>
        <NavButton
          title="Albums"
          icon={<MusicNoteIcon width={22} height={22} />}
          isActive={isAlbums}
          onClick={() => navigate({ to: "/marketplace/albums" })}
        />
      </Flex>

      {/* Creator Marketplace (Beats / Sound Kits / gated Songs) removed from
        the nav — the routes still exist for direct links. */}

      <Separator className="w-full mb-[16px] bg-background-quarternary" />
    </LeftNav>
  );
}
